import React from 'react'

import NameSection from '../sections/NameSection'
import RightDatesSection from '../../../ReusableSections/RightDatesSection'
import RightAllocationAndDelivery from '../../../ReusableSections/RightAllocationAndDelivery'
import RequestAssetsSection from '../../../ReusableSections/RequestAssetsSection'
import ActionsOrCommentsSection from '../../../ReusableSections/ActionsOrCommentsSection'

function OtherRightEditSections({ formik }) {
  return (
    <>
      <NameSection formik={formik} />
      <RightDatesSection formik={formik} />
      <RightAllocationAndDelivery formik={formik} />
      <RequestAssetsSection formik={formik} />
      <ActionsOrCommentsSection formik={formik} />
    </>
  )
}

export default OtherRightEditSections
